import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_generics__avatar'

export const elements = object(null, {})

export const modifiers = object(null, {})
